import { Injectable } from '@angular/core';
import { convertToParamMap, Router } from '@angular/router';
import { of, Subject, BehaviorSubject, Observable, combineLatest, pipe } from 'rxjs';
import { tap, switchMap, skip, share, map, filter, shareReplay, distinctUntilChanged, takeUntil, takeWhile, take } from 'rxjs/operators';
import { DefaultIndexDoc, ConditionInput, SearchGQL, SearchApiSearch, SearchQuery, ConjunctionOperator } from '@app/graphql';
import { emitOnce } from '@ngneat/elf';
import { SortBy, CONSTANTS, Chip, Taxonomies, sortOptions, Pager, BUFFER, DataSource } from '@app/constants';
import { PagesService, TaxonomyService, StoreService, FacetsService, ScreenService } from '@app/data';



@Injectable({
  providedIn: 'root'
})
export class FetchService {
  public taxonomyDone$: Observable<any> = this.taxonomy.taxonomyDone$;
  //private taxonomy$: Observable<Taxonomies[]> = this.facets.taxonomy$;
  private _route$: Observable<any> = this.pages.route$;

  constructor(
    private search: SearchGQL,
    private pages: PagesService,
    private taxonomy: TaxonomyService,
    private store: StoreService,
    private facets: FacetsService,
    private screen: ScreenService,
    private router: Router
  ) {}

  public getStore = (dataSource: DataSource) => {
    console.log('===> FetchService getStore dataSource ', dataSource);    

    const page = dataSource.static ? 
      {
        pageName: dataSource.storeName,
        queryParams: {},
        fullText: ''
      } 
      : this.pages.getCurrentPage();
    const store = this.store.getStore(page);
    //const storeName = page.pageName;
    return this.createPager(store, dataSource);
  }

  private createPager = (store: any, dataSource: DataSource) => {
    console.log('===> FetchService createPager store ', store);    
    console.log('===> FetchService createPager dataSource.storeName ', dataSource.storeName);

    let initStaticStore = dataSource.static ? true : false;  
    
    const pager$ = combineLatest([
      this.taxonomyDone$,
      this._route$ 
    ]).pipe(
      filter(([taxonomyDone, route]) => route.pageName === dataSource.storeName || initStaticStore),
      //store.skipWhileStoreCached(([taxonomyDone, route]: [any, any]) => route.cacheId),
      //tap((_: any) => console.log('#### FetchService pagination$ TAP getPage _ ', _)),
      switchMap(([taxonomyDone, route]) => {
        console.log('#### FetchService pagination$ getPage route ', route);
        console.log('#### FetchService pagination$ getPage route.cacheId ', route.cacheId);
        //console.log('#### FetchService pagination$ getPage store ', store);
        //console.log('#### FetchService pagination$ getPage storeName ', storeName);

        if (dataSource.static) {
          initStaticStore = false;
        }

        const cache = route.cacheId === store.getCache();

        console.log('#### FetchService pagination$ getPage cache ', cache);

        if (!cache) {
          store.setCache(route.cacheId);
        }

        const isEmpty = store.isEmpty() || !cache;
        const queryParams = JSON.parse(JSON.stringify(route.queryParams));
        const sort = queryParams.seradit ? queryParams.seradit : 'created-DESC';
        const sortBy: SortBy = sortOptions.filter(option => option.value === sort)[0];
        const fullText = queryParams.text ? queryParams.text : '';
        const currentPage: number = /*isEmpty ? 1 :*/ queryParams.strana ? queryParams.strana * 1 : 1;
        const pageUp = currentPage > store.getCurrentPage();
        const total = store.getTotal();
        const limit = isEmpty ? route.data.limit * (currentPage === 1 ? 2 : 3) : route.data.limit;

        const computedOffset = isEmpty ? (currentPage - 1) * route.data.limit :
                              pageUp ? currentPage * limit :
                                      (currentPage - 2) * limit;

        const offset = isEmpty ? (computedOffset - route.data.limit > 0 ? computedOffset - route.data.limit : 0) : 
                        pageUp ? (currentPage) * limit :
                                   0;

        const storeOffset = isEmpty ? offset : store.getStoreOffset();
        const lastPage = Math.ceil(total/route.data.limit);
        const hasNextCache = pageUp && currentPage !== lastPage && store.hasPage(currentPage + 1);
        const hasPrevCache = !pageUp && currentPage !== 1 && store.hasPage(currentPage - 1);

        console.log('#### FetchService pagination$ getPage currentPage ', currentPage);
        console.log('#### FetchService pagination$ getPage queryParams ', queryParams);

        if (!isEmpty && store.hasPage(currentPage) && (hasNextCache || hasPrevCache || currentPage === 1 || currentPage === lastPage)) {

          const pager: Pager = {
            limit,
            lastPage,
            currentPage,
            total,
            pageItems: [],
            queryParams,
            isEmpty,
            pageUp
          };

          if (route.data.detail && route.params.id) {
            const detail = store.setDetail('/' + route.params.id);
            this.screen.setScreenStore(detail);
          }

          store.setCurrentPage(pager);

          return of(pager);
        }

        //console.log('#### FetchService pagination$ getPage store.hasPage(currentPage) ', store.hasPage(currentPage));

        const { fetchParams, activeFilters } = this._getParams({
          dataSource,
          route,
          currentPage,
          queryParams,
          sort,
          limit,
          offset
        });

        /* SET STORE */

        emitOnce(() => {
          store.setStatus('pending');
          store.setCount('');
          store.setStoreOffset(storeOffset),
          store.setPageParams({
            activeFilters,
            queryParams: route.queryParams,
            sortBy,
            fullText,
            isEmpty
          });  
        });

        console.log('#### FetchService pagination$ getPage fetchParams ', fetchParams);
        //console.log('#### FetchService pagination$ getPage activeFilters ', activeFilters);

        return this.search.fetch(fetchParams).pipe(
          tap(res => console.log('#### FetchService _getPage res ', res)),
          //tap(res => (fetchParams.pageName !== 'doporucujeme' || fetchParams.pageName !== 'uvod') ? this.taxonomy.setFacets(res!.data!.searchAPISearch!.facets!) : ''),
          map((res: any) => {

            const limit: number = route.data.limit;
            const total: number = res!.data!.searchAPISearch!.result_count!;
            const lastPage: number = Math.ceil(total / limit);
            const { collection, collectionIds } = this.normalizeCollection(res!.data!.searchAPISearch!.documents, offset, limit);

            if (isEmpty) {
              this.facets.setFacets(res!.data!.searchAPISearch!.facets, route.queryParams);
            }

            let detail = false;
            const pager: Pager = {
              limit,
              lastPage,
              currentPage,
              total,
              pageItems: collectionIds,
              queryParams,
              isEmpty,
              pageUp
            };

            emitOnce(() => {
              store.setStatus('success');
              store.setCount(total.toString());
              
              if (!isEmpty) {
                store.addStoreEntities(pager, collection); 
              }
              else {
                store.setStoreEntities(pager, collection); 
              }
              if (route.data.detail && route.params.id) {
                detail = store.setDetail('/' + route.params.id);
              }

            });

            console.log('#### FetchService pagination$ fetch detail ', detail);

            if (route.data.detail && route.params.id) {
              // maybe we are comming from canonical url and don't know the page number so redirect if detail is not in store
              if (detail) {
                this.screen.setScreenStore(detail);  
              }
              else {
                const newQueryParams = queryParams.strana ? {...queryParams, strana: (queryParams.strana * 1) + 1} : {...queryParams, strana: '2'};
                console.log('#### FetchService pagination$ fetch newQueryParams ', newQueryParams);
                this.router.navigate([route.url], {queryParams: newQueryParams});
              }
              
            }

            return pager;
          })
        );
      })
    ).pipe(shareReplay({ bufferSize: 1, refCount: true }));
    return {
      pager$,
      ...store
    };
  }

  /* COLLECTION */

  private normalizeCollection = (inputCollection: DefaultIndexDoc[], offset: number, limit: number) => {
    //console.log('FetchService normalizeCollection inputCollection ', inputCollection);

    let collection = [];
    let collectionIds = [];
    let _offset = offset;

    for (var i = 0; i <= inputCollection.length - 1; i++) {
      _offset++;

      const item = inputCollection[i];     
      const { field_logo_1, field_logo_margin_1 } = this.normalizeLogo(item);
      const field_image_url = CONSTANTS.baseUrl + (item.field_image_url || item.field_image_url_1);
      const field_image_position_1 = item.field_image_position_1 || item.field_image_position_2;
      const summary = item.summary || item.field_short_description;
      const page_name = this.getPageName(item);
      
      collection.push({
        ...item,
        field_image_url,
        field_logo_1,
        field_logo_margin_1,
        body: this.normalizeBody(item.body),
        field_image_position_1,
        summary,
        page_name,
        chips: this.taxonomy.getChipsFromArticle(item),
        page: Math.ceil(_offset/limit)
      });

      collectionIds.push(item.url);
    }

    return { collection, collectionIds };
  };

  private _getParams = (input: any): any => {
    console.log('FetchService _getParams input ', input);
    //console.log('FetchService _getParams input.dataSource.storeName ', input.dataSource.storeName);

    let { conditions, activeFilters } = this._getConditions(input);
    const sortBy = input.sort.split('-');
    let sort = [{field: sortBy[0], value: sortBy[1]}];
    const fullText = input.queryParams.text ? input.queryParams.text : '';
    const limit = input.dataSource.static ? 4 : input.limit;
    const offset = input.dataSource.static ? 0 : input.offset;

    if (input.queryParams.text) {

      const fullTextEntity = this.getEntityQueryParams({
        entityLabel: fullText,
        facetsGroup: 'text'
      }, 'text', input.queryParams);

      activeFilters.push(fullTextEntity);
    }

    // make sure the second sorting parameter is by created
    if (sort[0].field !== 'created') {
      sort.push({field: "created", value: "DESC"});
    }
    
    const fetchParams = {
      index_id: 'default_index', 
      fulltext: {keys: [fullText], fields: ['title', 'field_sub_title', 'body', 'field_short_description', 'summary']},
      facets: [
        {field: 'stitky', limit: 0, operator: '=', min_count: 0, missing: false},
        {field: 'sekce', limit: 0, operator: '=', min_count: 0, missing: false},
        {field: 'partneri', limit: 0, operator: '=', min_count: 0, missing: false},
        {field: 'skoly', limit: 0, operator: '=', min_count: 0, missing: false}
      ],
      conditions,
      range: { offset, limit },
      sort
    };

    return { fetchParams, activeFilters };
  };

  private _getConditions = (input: any) => {
    console.log('FetchService _getConditions input', input);

    let conditions: ConditionInput[] = [{operator: "=", name: "published", value: "1"}];
    let activeFilters: Taxonomies[] = [];

    if (input.dataSource.storeName === '/recommended') {
      conditions.push({operator: "=", name: "field_recommended", value: "1"});
      return { conditions, activeFilters };
    }

    if (input.dataSource.storeName === '/recommended_ukrajinu') {
      conditions.push({operator: "=", name: "field_recommended_ukrajinu", value: "1"});
      return { conditions, activeFilters };
    }

    if (input.route.data.virtualParent) {

      let entity = this.facets.getEntity(input.dataSource.storeName);

      if (entity) {
        conditions.push({operator: '=', name: 'sekce', value: entity.entityId});
      }
    }

    if (input.dataSource.storeName.includes('/inspirace/inspirativni-skoly')) {
      const url = input.dataSource.storeName.replace('/inspirace/inspirativni-skoly', '');
      const entity = this.facets.getEntity(url);
      conditions.push({operator: '=', name: 'skoly', value: entity.entityId});
    }
    else if (input.dataSource.storeName.includes('/inspirace/inspirativni-organizace')) {
      const url = input.dataSource.storeName.replace('/inspirace/inspirativni-organizace', '');
      const entity = this.facets.getEntity(url);
      conditions.push({operator: '=', name: 'partneri', value: entity.entityId});
    }

    Object.keys(input.queryParams).forEach((key: string, index: any) => {
      //console.log('FetchService key', key);
      
      if (key !== 'text' && key != 'seradit' && key !== 'strana') {

        const tags = input.queryParams[key] instanceof Array ? input.queryParams[key] : [input.queryParams[key]];

        tags.forEach((tag: string) =>  {
          console.log('FetchService _getConditions key ', key);
          console.log('FetchService _getConditions tag ', tag);

          let entity = this.facets.getEntity(tag);

          if (entity) {
            conditions.push({operator: '=', name: key, value: entity.entityId});
            if (tag !== input.dataSource.storeName && key !== 'podstranka') {
              activeFilters.push(this.getEntityQueryParams(entity, key, input.queryParams));
            }
          }
        });
      }
    });

    console.log('FetchService _getConditions conditions ', conditions);
    return { conditions, activeFilters };
  }

  private getEntityQueryParams = (entity: any, key: string, queryParams: any): any => {
    const populatedChip = {
      ...entity,
      facetsGroup: key,
      selected: true
    }

    populatedChip.queryParams = this.facets.getFacetsQueryParams(populatedChip, queryParams);
    return populatedChip;
  };

  private getPageName = (item: any): string => {
    //console.log('FetchService getPageName item ', item);

    let pageName;

    if (item.page_name) {
      pageName = (item.page_name instanceof Array && item.page_name.length > 0) ? item.page_name[0] : item.page_name;
    }
    if (item.page_name_1) {
      pageName = (item.page_name_1 instanceof Array && item.page_name_1.length > 0) ? item.page_name_1[0] : item.page_name_1;
    }

    return pageName;
  };

  private normalizeLogo = (item: DefaultIndexDoc) => {
    //console.log('FetchService normalizeBody item ', item);

    const index = item.field_logo_1 ? 1 : item.field_logo_2 ? 2 : item.field_logo_3 ? 3 : item.field_logo_4 ? 4 : false;
    let field_logo_1 = undefined;
    let field_logo_margin_1 = undefined;

    switch(index) {
      case 1: {
        field_logo_1 = CONSTANTS.baseUrl + item.field_logo_1;
        field_logo_margin_1 = item.field_logo_margin_1;
        break;
      }

      case 2: {
        field_logo_1 = CONSTANTS.baseUrl + item.field_logo_2;
        field_logo_margin_1 = item.field_logo_margin_2;
        break;
      }

      case 3: {
        field_logo_1 = CONSTANTS.baseUrl + item.field_logo_3;
        field_logo_margin_1 = item.field_logo_margin_3;
        break;
      }

      case 4: {
        field_logo_1 = CONSTANTS.baseUrl + item.field_logo_4;
        field_logo_margin_1 = item.field_logo_margin_4;
        break;
      }
    }

    return { field_logo_1, field_logo_margin_1 };
  };

  private normalizeBody = (body: string | undefined | null): string | undefined => {
    //console.log('DataService normalizeBody body ', body);

    let absoluteBody;

    if (body) {
      absoluteBody = body.split('/sites/default/files').join(CONSTANTS.baseUrl + '/sites/default/files');
      absoluteBody = absoluteBody.split('<a href').join('<a target="_blank" href');

    }
    
    return absoluteBody;
  };

  private isEqual = (a: any, b: any) => JSON.stringify(a) === JSON.stringify(b);
}


